import api from 'api/apiInstance';
import type { FactFindData } from 'components/FactFind/types';

export function clientFactFindsMostRecentlySubmittedApi(path: string) {
  return {
    path,
    GET: () => api.get<FactFindData>(path),
  };
}
